import { MDBIcon } from 'mdbreact';
import React, { Component } from 'react';
import { URLImgFront } from '../../config/URLDB';

class Seccion1 extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }
    render() {
        return (
            <React.Fragment>
                <div className="diseño_responsive_view" style={{ width: '100%', paddingTop: '120px' }}>
                    <img style={{ width: '100%', height: '90vh', marginBottom: '15px', objectFit: 'cover' }} className="img-fluid" src={`${URLImgFront}/assets/img_principal/PortadaServcicios.webp`} alt="PORTADA NUESTROS SERVICIOS" />
                    <span className="ml-4 pt-4" style={{ fontSize: '20px' }}><MDBIcon icon="caret-right" className="ml-2 mr-1" /> Servicios</span>
                    <div className="vista_p_ahorro_credito" style={{ position: 'absolute', bottom: '80px', left: '140px' }}>
                        <p className="my-0" style={{ fontSize: '60px', color: '#FFF' }}>Conoce todos los servicios</p>
                        <p className="my-0" style={{ fontSize: '60px', color: '#FFF' }}>que <span style={{fontWeight: 'bold' }}>UTRAHUILCA</span></p>
                        <p className="pb-5" style={{ fontSize: '60px', color: '#FFF' }}>tiene para ti.</p>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default Seccion1;